import { Paragraph, TextRun } from "docx";



export const followingTests = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 450, after: 400 },
    children: [
        new TextRun({
            text: "The following tests are conducted as part of the Penetration Testing:",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            italics: false
        })
    ]
})

export const coveredPoint1 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Application Fingerprinting",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})
export const coveredPoint2 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Passive and Active testing",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint3 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "OWASP/MSTG top 10 2023",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint4 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Vulnerability Identification and Analysis",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint5 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Exploitation of Vulnerabilities",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint6 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "API Testing",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})
export const coveredPoint7 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "SQL Injection",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint8 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Password attacks",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint9 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Business Logic Testing",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint10 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 350, },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "HTTP methods",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const coveredPoint11 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 350, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Access Control Tests",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})
export const coveredPoint12 = new Paragraph({
    indent: { left: 1500, right: 600 },
    spacing: { line: 350, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Android Code Analysis",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})